import { render, staticRenderFns } from "./CustomerSpecificOrdersDelete.vue?vue&type=template&id=a2cd6ab6&scoped=true"
import script from "./CustomerSpecificOrdersDelete.vue?vue&type=script&lang=js"
export * from "./CustomerSpecificOrdersDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cd6ab6",
  null
  
)

export default component.exports